import { ArrowForward} from '@mui/icons-material';
import { Button } from '@mui/material';
import {useNavigate } from 'react-router-dom';

import { DrawIconsUnauthorized } from '../../data/SVGs';
import useRole from '../../hooks/useRole';
//import Footer from './shared/Footer/Footer';
import useWindowSize from '../../hooks/useWindowSize';
//import useRole from '../hooks/useRole';
import { buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
//import NavbarHome from './shared/Navbar/NavbarHome';

const Unauthorized = () => {
    const navigate = useNavigate();
    const role=useRole();
    //const goBack = () =>
    //    navigate(-1);
    // navigate("/");
    const {device}=useWindowSize();

    return (

        //<section>
        //    <h1>Unauthorized</h1>
        //    <br />
        //    <p>You do not have access to the requested page.</p>
        //    <div className="flexGrow">
        //        <Link to="/">Visit Our Homepage</Link>
        //        <div className="flexGrow">
        //            <Button
        //                variant='contained'
        //                onClick={goBack}
        //            >Go Back</Button>
        //        </div>
        //        <Logout className='items' />
        //    </div>
        //</section>
        <div
            className='App-intro'
            style={{height:'100%'}}
        >
            {/*<NavbarHome />*/}
            <div className='errorF0'>
                <DrawIconsUnauthorized width={device=='desktop'?'804':'100%'}/>
                <div className='errorF1'>
                    <h5
                        className='pricingF25'
                        style={{color:'#272D3C'}}
                    >Unauthorized access</h5>
                    <h6
                        className='pricingF26'
                        style={{color:'#B0B0B0'}}
                    >Unauthorized: authentication credentials were missing or incorrect. Please try again</h6>
                </div>
                <div className="flexGrow">
                    <div className="flexGrow">
                        <Button
                            variant='contained'
                            onClick={()=>{
                                navigate(`/${role}/`,{replace:true});
                                // navigate(-1);
                                // navigate('/');
                                console.log(`/${role}/`);
                            }}
                            style={{...buttonStylesBlue()}}
                            startIcon={<ArrowForward />}
                        >Retour</Button>
                    </div>
                </div>
            </div>
            {/*<Footer />*/}
        </div>
    );
};

export default Unauthorized;